import { render, staticRenderFns } from "./OutpatientReviewPx.vue?vue&type=template&id=7d0bc7aa&scoped=true&"
import script from "./OutpatientReviewPx.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewPx.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientReviewPx.vue?vue&type=style&index=0&id=7d0bc7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0bc7aa",
  null
  
)

export default component.exports